import Api from '../../../helpers/Api';

export const SET_PROGRAMS_DATA = 'SET_PROGRAMS_DATA';
export const setProgramsData = (programsData) => ({
    type: SET_PROGRAMS_DATA,
    programsData,
});

export const fetchProgramsDataIfNeeded = () => (dispatch, getState) => {
    const { programsData } = getState().programs;

    if (programsData.length > 0) {
        return Promise.resolve(1);
    }

    return Api.progressGet(dispatch, '/api/v1/programs/getProgramsData').then((json) => {
        if (json.status !== 'success') {
            throw `error from server: ${json.message}`;
        }

        return dispatch(setProgramsData(json.data));
    }).catch((error) => {
        // eslint-disable-next-line no-console
        console.log('fetchProgramsDataIfNeeded got error: ', error);
    });
};
